import { useQuery } from 'react-query';

import { getLargestFloatChanges as queryFn } from 'api/endPoints/getLargestFloatChanges';

export const useQueryLargestFloatChangesTableData = (params) => {
    return useQuery(['largestFloatChangesTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
